var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50933 0.0921631C4.30262 0.0921631 0.0836792 4.31217 0.0836792 9.5177C0.0836792 14.7232 4.30262 18.9433 9.50933 18.9433C14.7149 18.9433 18.935 14.7232 18.935 9.5177C18.935 4.31217 14.7149 0.0921631 9.50933 0.0921631ZM14.6145 9.91068H10.457L13.3211 12.7748C13.4746 12.9283 13.4746 13.1773 13.3211 13.3307C13.2444 13.4074 13.1441 13.4451 13.0438 13.4451C12.9435 13.4451 12.842 13.4074 12.7653 13.3307L9.90113 10.4665V14.6241C9.90113 14.8414 9.7253 15.0159 9.50933 15.0159C9.29219 15.0159 9.11635 14.8414 9.11635 14.6241V10.4665L6.25219 13.3307C6.17548 13.4074 6.07517 13.4451 5.97368 13.4451C5.87337 13.4451 5.77306 13.4074 5.69635 13.3307C5.54293 13.1773 5.54293 12.9283 5.69635 12.7748L8.56051 9.91068H4.40293C4.18697 9.91068 4.00995 9.73484 4.00995 9.5177C4.00995 9.30055 4.18697 9.1259 4.40293 9.1259H8.56051L5.69635 6.26055C5.54293 6.10714 5.54293 5.85931 5.69635 5.7059C5.84977 5.55248 6.09877 5.55248 6.25219 5.7059L9.11635 8.57006V4.4126C9.11635 4.19534 9.29219 4.0195 9.50933 4.0195C9.7253 4.0195 9.90113 4.19534 9.90113 4.4126V8.57006L12.7653 5.7059C12.9187 5.55248 13.1677 5.55248 13.3211 5.7059C13.4746 5.85931 13.4746 6.10714 13.3211 6.26055L10.457 9.1259H14.6145C14.8317 9.1259 15.0075 9.30055 15.0075 9.5177C15.0075 9.73484 14.8317 9.91068 14.6145 9.91068Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.616ff844d5a3c5cf3004b3de8cd79fe3.svg";
export { ForwardRef as ReactComponent };